/**
 * Console log helper
 * @param messages Messages
 */
const logger = (...messages: any[]) => {
  if (process.env.REACT_APP_LOGGER || process.env.NODE_ENV !== 'production') {
    console.log(...messages);
  }
};

export const permaLogger = (...messages: any[]) => {
  console.info(`[${new Date().toISOString()}]`, ...messages);
};

export default logger;
